import React from "react";
import PropTypes from "prop-types";
import StoryCardAspectRatioOne from "../../../../../atoms/story-card-aspect-ratio-one";

import styles from "./styles.m.css";
import { getStoryHeadline } from "../../../../../utils/utils";

const RelatedStories = ({ collection, className = "" }) => {
  const stories = collection.items
    ? collection.items.filter(({ story = {} }) => getStoryHeadline(story) && story.url).map(item => item.story)
    : [];
  return stories.length ? (
    <div className={`${styles.base} ${className}`}>
      {collection.name && <h2 className={`${styles.headline}`}>{collection.name}</h2>}
      <div className={styles["stories-container"]}>
        {stories.map(story => (
          <StoryCardAspectRatioOne
            key={story.id}
            story={story}
            className={styles["related-story"]}
            artfrm="story_latest_news"
          />
        ))}
      </div>
    </div>
  ) : null;
};

RelatedStories.propTypes = {
  className: PropTypes.string,
  collection: PropTypes.shape({
    name: PropTypes.string,
    id: PropTypes.number,
    type: PropTypes.string,
    slug: PropTypes.string,
    readMoreText: PropTypes.string,
    items: PropTypes.arrayOf(
      PropTypes.shape({
        type: PropTypes.string,
        story: PropTypes.shape({
          id: PropTypes.string,
          contributors: PropTypes.arrayOf(
            PropTypes.shape({
              "role-name": PropTypes.string,
              authors: PropTypes.arrayOf(
                PropTypes.shape({
                  name: PropTypes.string
                })
              )
            })
          ),
          headline: PropTypes.string.isRequired,
          subheadline: PropTypes.string,
          alternative: PropTypes.shape({
            home: PropTypes.shape({
              default: PropTypes.shape({
                headline: PropTypes.string
              })
            })
          })
        })
      })
    )
  })
};

export default RelatedStories;
